module.exports = __webpack_public_path__ + "static/drone-a81833ec245ecebb3e873abbd2032125.webp";